import { useEffect, useState } from "react";
import PerformanceDayBrandsFilter from "./PerformanceDayBrandsFilter/PerformanceDayBrandsFilter";
import PerformanceDayBrandsGraph from "./PerformanceDayBrandsGraph/PerformanceDayBrandsGraph";
import PerformanceDayBrandsTable from "./PerformanceDayBrandsTable/PerformanceDayBrandsTable";
import { Divider } from "@mui/material";
import { engagementIncentivesEndPointLogic } from "../../../../logic/PaidTrafficManagement/EngagementIncentives/engagementIncentivesEndPointLogic";
import SimpleBackdrop from "../../../BackDrop/BackDrop";
import { useSelector } from "react-redux";

const tableHeadings = {
  action_date: "Date of Aquisition",
  brand_name: "Brand Name",
  clicks: "Clicks",
  registrations: "Registrations",
  ftd: "FTD",
  qftd_actual: "Actual QFTD",
  cost: "Cost ($)",
};

interface PerformanceDayBrandsProps {
  selectedSiteUids: any;
  userToken: string;
  siteSelectionTrigger: any;
}

const PerformanceDayBrands = ({
  selectedSiteUids,
  userToken,
  siteSelectionTrigger,
}: PerformanceDayBrandsProps) => {
  const [exequteQueryContentQuery4, setExequteQueryContentQuery4] = useState(
    []
  ) as any;
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [show, setShow] = useState<boolean>(true);
  const [display, setDisplay] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [brandName, setBrandName] = useState([]);
  const [sortedRows, setSortedRows] = useState([]);
  const dataSetType = useSelector(
    (state: any) => state.engagementIncentives.dataSetType
  );
  const isClickDate = dataSetType === "click_date";
  const competitorlisting =
    exequteQueryContentQuery4?.query_output
      ?.map((brandNames: any) => brandNames?.brand_name)
      .filter(Boolean) || [];
  const QUERY_ID_4 = isClickDate ? 6233342794006528 : 5767385684377600;

  useEffect(() => {
    const fetchExequteQueryContent = async () => {
      if (startDate && endDate && show === true) {
        setLoading(true);
        try {
          // Await the API call to ensure it completes before moving on
          await engagementIncentivesEndPointLogic.getExequteQuery(
            userToken,
            setExequteQueryContentQuery4,
            selectedSiteUids,
            startDate,
            endDate,
            QUERY_ID_4
          );
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          // This ensures loading is set to false after the API call, regardless of success or failure
          setLoading(false);
          setShow(false);
        }
      }
    };

    fetchExequteQueryContent();
    // eslint-disable-next-line
  }, [startDate, endDate, show, selectedSiteUids]);

  useEffect(() => {
    setShow(true); // This will force a re-fetch when the SELECT SITE button is clicked
  }, [siteSelectionTrigger]);

  return (
    <>
      <PerformanceDayBrandsFilter
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        setShow={setShow}
        setDisplay={setDisplay}
        competitorlisting={competitorlisting}
        setBrandName={setBrandName}
        tableHeadings={tableHeadings}
        sortedRows={sortedRows}
        brandName={brandName}
      />
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          {exequteQueryContentQuery4 && display && (
            <>
              <Divider />
              <PerformanceDayBrandsGraph
                exequteQueryContentQuery4={exequteQueryContentQuery4}
                brandName={brandName}
              />
              <PerformanceDayBrandsTable
                tableHeadings={tableHeadings}
                exequteQueryContentQuery4={exequteQueryContentQuery4}
                brandName={brandName}
                setSortedRows={setSortedRows}
                sortedRows={sortedRows}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default PerformanceDayBrands;
